import { html } from '@microsoft/fast-element';
export const ProtectedTemplate = html `
  <div class="container">
    <zero-button
      type="button"
      appearance="primary-gradient"
      @click=${(x) => x.onLogout()}
      data-test-id="logout"
    >
      Logout
    </zero-button>
  </div>
`;
